import { useState } from 'react'
import Box from '@mui/material/Box'
import styled from '@emotion/styled'
import { GtmAgent } from 'utils/hooks/analytics'

const ItemWrapper = styled(Box)`
  ${({ theme, $hovered }) => `
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding: 8px 0;
    cursor: pointer;

    ${theme.breakpoints.down('lg')} {
      flex-direction: column;
    }
  `}
`

const ItemTitle = styled(Box)`
  ${({ theme, $hovered }) => `
    font-weight: 400;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 16px;
    color: ${$hovered ? theme.palette.primary.main : theme.palette.text.minus1};
  `}
`

const GridItemText = ({
  item,
  menuDataForGa,
  subMenuDataForGa,
  subCatalogDataForGa,
  handleClose,
  onServiceClassificationClick,
  hasSubMenu,
}) => {
  const [hovered, setHovered] = useState(false)

  return (
    <ItemWrapper
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      $hovered={hovered}
      onClick={() => {
        GtmAgent.directSendToGTM({
          event: 'living_action',
          living_event_name: 'headermenu_click',
          living_click_name:
            item?.type === 'serviceClassification'
              ? item?.serviceClassification?.name
              : item?.name,
          living_click_location: 'web_主選單細項',
          ...(item?.serviceClassification?._id && {
            living_click_id: item.serviceClassification._id,
          }),
          living_category1_name: menuDataForGa?.name,
          ...(menuDataForGa?._id && { living_category1_id: menuDataForGa._id }),
          ...(subMenuDataForGa?.name &&
            hasSubMenu && {
              living_category2_name: subMenuDataForGa.name,
            }),
          ...(subMenuDataForGa?._id &&
            hasSubMenu && {
              living_category2_id: subMenuDataForGa._id,
            }),
          living_category3_name: subCatalogDataForGa?.name,
          ...(subCatalogDataForGa?._id && {
            living_category3_id: subCatalogDataForGa._id,
          }),
        })

        handleClose()
        onServiceClassificationClick(item)
      }}
    >
      <Box>
        <ItemTitle $hovered={hovered}>
          {item.type === 'serviceClassification'
            ? item?.serviceClassification?.name
            : item?.name}
        </ItemTitle>
      </Box>
    </ItemWrapper>
  )
}

export default GridItemText
